import { getWhitelabelCss } from '@agentselly/ui';

interface Props {
  readonly companyId?: string;
}

/**
 * Injects the per-company whitelabel token overrides (light + dark) from
 * `@agentselly/ui`. Renders nothing for companies without whitelabel.
 */
export function WhitelabelStyle({ companyId }: Props) {
  const css = getWhitelabelCss(companyId);
  if (!css) {
    return null;
  }
  return <style data-whitelabel={companyId}>{css}</style>;
}
